import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_API_BASE_URL;

class TerrainService {
  getTerrainById(terrain_id){
    return axios.get(API_URL + 'terrain/' + terrain_id, { headers: authHeader() })
    .then(response => {
      return response.data; 
    });
  }

  getTerrainsByLandlordId(landlord_id){
    return axios.get(API_URL + 'terrain', { headers: authHeader() })
    .then(response => {
      let terrain_list = [];
      response.data.forEach(terrain =>{
        if(terrain.landlord_id == landlord_id){
          terrain_list.push(terrain);
        }
      })
      return terrain_list; 
    },
    error => {
      console.log(error)
    });
  }

  createTerrain(terrain_model){
    return axios.post(API_URL + 'terrain/', terrain_model, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  updateTerrainById(terrain_id, terrain_model){
    return axios.patch(API_URL + 'terrain/'+terrain_id, terrain_model, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  updateTerrainReportById(terrain_id, terrain_model){
    const report = {report: terrain_model.report}
    return axios.patch(API_URL + 'terrain/'+terrain_id+'/report', report, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  deleteTerrainById(terrainId){
    return axios.delete(API_URL + 'terrain/'+terrainId+'?deep_delete=true', {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }
}

export default new TerrainService();